function init(piwik) {
    if (piwik) {
        var Tracker = piwik.getAsyncTracker();
        if (Tracker) {
            Tracker.enableHeartBeatTimer(15);
            document.body.addEventListener("click", function(evnt) {
                if (evnt.target.matches(".actions-menu__link")) {
                    var action = evnt.target.className.indexOf("bonus-link") > -1 ? "Bonus" : evnt.currentTarget.className.indexOf("notes-link") > -1 ? "Notes" : "ActivityCenter";
                    _trackEvent("ActionMenuClick", action, "Toggle");
                }
                if (evnt.target.matches(".chart-nav")) {
                    _trackEvent("ChartNavClick", evnt.target.className.indexOf("next") > -1 ? "Next" : "Prev");
                }
                if (evnt.target.matches(".menu-toggler")) {
                    _trackEvent("ToggleMenuClick", "");
                }
                if (evnt.target.matches(".app-menu__print")) {
                    _trackEvent("PrintView", "Print View opened", "PrintView:Open");
                }
                if (evnt.target.matches(".ui-switch")) {
                    setTimeout(function() {
                        _trackEvent("ToggleStoryModeMode", evnt.target.className.indexOf("on") > -1 ? "story Mode" : "book Mode");
                    }, 50);
                }
                if (evnt.target.matches('[name="printBtn"]')) {
                    _trackEvent("PrintView", 'Clicked on "Print"', "PrintView:Print", document.querySelector(".layout-select .ui-select__selected").innerText);
                }
            });
        }
        return !!Tracker;
    }
    return false;
}
var initTries = 0, _maxRetries = 8000 / 200, _Tracker = null;
function lazyInit() {
    if (_Tracker) {
        return;
    }
    if (initTries > _maxRetries) {
        console.warn("Piwik: Could not enable Tracking.");
        return;
    }
    initTries++;
    if (window.Piwik && init(window.Piwik)) {
        _Tracker = window.Piwik.getAsyncTracker();
        console.log("Piwik: Tracking is enabled.");
    } else {
        setTimeout(lazyInit, 200);
    }
    return null; // Always null
}
function _trackEvent() {
    if (_Tracker) {
        _Tracker.trackEvent.apply(_Tracker, arguments);
    }
}
// trackEvent has the same shape as the trackEvent function from piwik
export default {
    trackEvent: _trackEvent,
    setCustomDimension: function setCustomDimension() {
        _Tracker && _Tracker.setCustomDimension.apply(_Tracker, arguments);
    },
    setUserId: function setUserId() {
        _Tracker && _Tracker.setUserId.apply(_Tracker, arguments);
    }
};
lazyInit();
